import { FontWeights } from '@fluentui/react';
/** Factory function for MSRC's shared home button format. */
export const makeHomeButtonProps = (siteName = 'MSRC', href = '/') => ({
    buttonStyles: {
        root: {
            backgroundColor: 'transparent',
        },
        label: {
            color: '#fff',
            fontSize: '16px',
            fontWeight: FontWeights.semibold,
            '@media (max-width: 480px)': {
                fontSize: '12px',
            },
        },
    },
    href,
    key: 'msrcPortal',
    name: siteName,
});
